import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgXCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.99996 0.666748C3.94987 0.666748 0.666626 3.94999 0.666626 8.00008C0.666626 12.0502 3.94987 15.3334 7.99996 15.3334C12.05 15.3334 15.3333 12.0502 15.3333 8.00008C15.3333 3.94999 12.05 0.666748 7.99996 0.666748ZM10.4714 5.52868C10.7317 5.78903 10.7317 6.21114 10.4714 6.47149L8.94277 8.00008L10.4714 9.52868C10.7317 9.78903 10.7317 10.2111 10.4714 10.4715C10.211 10.7318 9.7889 10.7318 9.52855 10.4715L7.99996 8.94289L6.47136 10.4715C6.21101 10.7318 5.7889 10.7318 5.52855 10.4715C5.26821 10.2111 5.26821 9.78903 5.52855 9.52868L7.05715 8.00008L5.52855 6.47149C5.26821 6.21114 5.26821 5.78903 5.52855 5.52868C5.7889 5.26833 6.21101 5.26833 6.47136 5.52868L7.99996 7.05727L9.52855 5.52868C9.7889 5.26833 10.211 5.26833 10.4714 5.52868Z",
		fill: "currentColor"
	})
});
export default SvgXCircle;
